import { State } from './index';
import { se } from 'module/Common';
import { createSelector } from 'reselect';
import { RouterSelector } from 'module/Redux/Router';
import { Wish } from 'module/Model/Wish';
import { Page } from 'module/Model/Page';
import { RouteType } from 'module/Model/Routes';
import { WishCollection } from 'module/Model/WishCollection';

export namespace PageSelector {
  export const select = (s: State) => se(s, 'page', s.page);

  export const selectCurrent = createSelector(select, RouterSelector.selectMatchingRoute, (pages, route): Wish<
    Page
  > => {
    if (route === null) {
      return Wish.createVoid();
    }
    if (route.type === RouteType.Page) {
      return WishCollection.selectByKeyOrVoid(pages, { key: route.id });
    }
    return Wish.createVoid();
  });
}



// WEBPACK FOOTER //
// ./src/module/Redux/Page/PageSelector.ts